/**
 * The legs of a block time record, in flight order.
 */
export enum BlockTimeLegEnum {
  ObRepo = 'obRepo',
  LiveFlight = 'liveFlight',
  IbRepo = 'ibRepo',
}
